import React, { useCallback, useEffect, useState } from 'react'
import { HeaderPage } from '../../../components/HeaderPage'
import { SpinnerLoad } from '../../../components/Loading/SpinnerLoad'
import { ApproveOsc } from '../../../components/Osc/ApproveOsc'
import { ActuationAndPublic } from '../../../components/OscForm/OscFields/ActuationAndPublic'
import { ContactFields } from '../../../components/OscForm/OscFields/ContactFields'
import { GeneralDataFields } from '../../../components/OscForm/OscFields/GeneralDataFields'
import { LogoAndDescription } from '../../../components/OscForm/OscFields/LogoAndDescriptionFields'
import { PasswordField } from '../../../components/OscForm/OscFields/PasswordFields'
import { StructOrganizationFields } from '../../../components/OscForm/OscFields/StructOrganizationFields'
import useApi from '../../../hooks/useApi'
import { OscLoggedLayout } from '../../../layout/OscLoggedLayout'
import { Osc } from '../../../types/Osc'

export const Me = () => {

    const api = useApi()

    const [osc,setOsc] = useState<Osc>()
    const [load,setLoad] = useState<boolean>(false)
    const [edit,setEdit] = useState<boolean>(false)

    const loadMe = useCallback( async ()=>{
        setLoad(true)
        await api.get("/client/me/all").then(res=>{
            setOsc(res.data)
        }).catch(console.log)
        setLoad(false)
    },[api])


    useEffect(()=>{
        loadMe()
    },[loadMe])

    return(
        <OscLoggedLayout>
                <HeaderPage name='Meu Perfil' button={!edit ? <button className='bg-primary px-2 py-1 rounded-md' onClick={()=>setEdit(true)}>Editar Perfil</button>  :
                <button className='bg-primary px-2 py-1 rounded-md' onClick={()=>setEdit(false)}>Voltar</button>
                }/>
                {!load && edit &&
                <div  className='bg-gray-100 p-2 shadow-lg flex flex-col'>
                    <PasswordField />
                    <GeneralDataFields oldData={osc} update isPublic />
                    <hr/>
                    <ContactFields oldData={osc} update isPublic />
                    <ActuationAndPublic  oldData={osc} update isPublic />
                    <StructOrganizationFields oldData={osc} update isPublic  />
                    <LogoAndDescription oldData={osc} update isPublic />
                </div>}
                {!load && !edit && osc && <ApproveOsc oscArea currentOsc={osc}/>}
                {load && <SpinnerLoad/> }
        </OscLoggedLayout>
    )
}
